import { NgModule } from '@angular/core';

import { ApUploadbeheerResource } from './uploadbeheer.resource';

@NgModule({
    providers: [ApUploadbeheerResource]
})
export class ApUploadbeheerModule {}
